// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Courier_Prime_87c02c', '__Courier_Prime_Fallback_87c02c'","fontStyle":"normal"},"className":"__className_87c02c","variable":"__variable_87c02c"};